import {useQuery} from '@tanstack/react-query';
import {IntegrationConfig, IntegrationConfigListQueryParams} from 'src/core/data/api/IntegrationConfig';
import IntegrationConfigService from 'src/services/integration-config-service';

export const integrationConfigKeys = {
  all: ['integrationConfig'] as const,
  filters: () => [...integrationConfigKeys.all, 'filter']as const,
  filter: (query: IntegrationConfigListQueryParams) => [...integrationConfigKeys.filters(), 'filter', query] as const,
};

export const useIntegrationConfig = (query: IntegrationConfigListQueryParams = {}) => {
  const integrationConfigService = new IntegrationConfigService();

  return useQuery<unknown, unknown, IntegrationConfig[]>({
    queryKey: integrationConfigKeys.filter(query),
    queryFn: () => integrationConfigService.list(query),
    initialData: [],
    // The endpoint answers 403 for customers that are not central; retrying that is pointless.
    retry: false,
  });
};
